import React from "react";

import { StatutBadge } from "./StatutsCarto";
import {
  decrireStatut,
  formaterDateCourte,
  formaterDateHeure,
  libelleDepuis,
  statutModule,
} from "./cartographieDonnees";

const liste = (v) => (Array.isArray(v) ? v : []);
const COULEURS_FLUX = { ok: "#2e9e6b", warning: "#ff8801", error: "#e5484d", running: "#3b82f6", unknown: "#b8c0cc" };
const LIBELLES_FLUX = { ok: "ok", warning: "avertissement", error: "erreur", running: "en cours", unknown: "inconnu" };

// Carte d'un module : badge de statut, bloc Declare (settings) et bloc Observe (logs, 30 j).
export default function ModuleCarte({ module: m }) {
  const depuis = liste(m.since);
  const statuts = liste(m.statuses);
  const observes = liste(m.observed_sources);
  const st = statutModule(m);
  const classe = st === "missing" || st === "declared_not_observed" ? " alerte" : st === "observed_not_declared" ? " ecart" : "";
  return (
    <div className={`carto-carte${classe}`} data-testid="carte-module" data-statut={st}>
      <div className="carto-carte-titre">
        {m.label || m.code || m.name}
        <StatutBadge module={m} className="carto-carte-badge" />
      </div>
      <div className="carto-bloc">
        <div className="carto-bloc-titre">Déclaré</div>
        {!m.current_source && liste(m.previous_sources).length === 0 && (
          <div className="carto-sub">aucune source déclarée</div>
        )}
        <div>
          {m.current_source && <span className="carto-pill actuelle">{m.current_source.value}</span>}
          {liste(m.previous_sources).map((s) => (
            <span key={s.key} className="carto-pill anterieure">
              {s.value}
            </span>
          ))}
        </div>
        {depuis.length > 0 && (
          <div className="carto-sub">
            Depuis : {depuis.map((s) => `${libelleDepuis(s.key)} ${formaterDateCourte(s.value)}`).join(" · ")}
          </div>
        )}
        {statuts.length > 0 && (
          <div className="carto-sub">
            {statuts
              .map((s) => {
                const d = decrireStatut(s);
                return `${d.label} : ${d.valeur}`;
              })
              .join(" · ")}
          </div>
        )}
      </div>
      <div className="carto-bloc">
        <div className="carto-bloc-titre">Observé (30 j)</div>
        {observes.length === 0 && <div className="carto-sub">aucun flux observé sur 30 j</div>}
        {observes.map((o) => (
          <div key={o.provider} className="carto-flux">
            <span
              className="carto-pill observee"
              title={liste(o.jobs).join("\n")}
              data-testid="pilule-observee"
            >
              <span
                className="carto-flux-pastille"
                data-statut-flux={o.last_status || "unknown"}
                title={LIBELLES_FLUX[o.last_status] || LIBELLES_FLUX.unknown}
                style={{ background: COULEURS_FLUX[o.last_status] || COULEURS_FLUX.unknown }}
              />
              {o.provider}
            </span>
            <span className="carto-sub">
              {o.last_run_at ? ` dernier passage ${formaterDateHeure(o.last_run_at, "DD/MM HH:mm")}` : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
